/** @format */

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { ClientIdCombo, ButtonLoading } from 'components';
import { useForm } from 'react-hook-form';
import { Alert } from '@mui/material';
import { makeStyles } from '@mui/styles';

const DialogForm = ({ open, closeDialogForm, confirm, loading = false }) => {
  const methods = useForm();
  const classes = useStyles();

  const { handleSubmit } = methods;

  const onSubmit = (data) => {
    confirm(data);
  };

  const closeDialog = () => {
    closeDialogForm(false);
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} className={classes.dialogMain}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <DialogTitle id="simple-dialog-title" className={classes.title}>
          تایید درخواست
        </DialogTitle>

        <DialogContent>
          <ClientIdCombo methods={methods} setValueIndex="0" />
          <Alert severity="info" style={{ marginTop: '10px' }}>
            <h3>توجه</h3>
            <div>
              کلید اتصالی که انتخاب می‌کنید تنها برای درخواست‌هایی که کلید اتصال قبلا برای آن‌ها
              تعریف نشده است، تنظیم می‌شود
            </div>
          </Alert>
        </DialogContent>

        <DialogActions style={{ paddingBottom: 24 }}>
          <ButtonLoading
            name="تایید"
            variant="contained"
            color="primary"
            type="submit"
            loading={loading}
          />
          <Button variant="contained" onClick={closeDialog}>
            بستن
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
const useStyles = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
}));
export default DialogForm;
